import React from 'react';
import AsignarCursosPuestoCatalog from './AsignarCursosPuestoCatalog';

export default function AsignarCursosPuestoPage() {
    return (
        <div className="lms-page-container">
            <AsignarCursosPuestoCatalog />
        </div>
    );
}
